module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer2_offgrid_no-inverter-no-battery 1.677788ce.svg";